import client from '../_client';
import config from '~/config';

export const getInvestmentComparison = (params = {}) => {
    return client.request({
        url: config.api.benchmark.investmentComparison,
        method: 'GET',
        params,
    });
};
